import { Injectable } from '@angular/core';
import { PermissionManager } from '../typed-permissions/permission-manager';
import { AppPermissions } from '../typed-permissions/app-permissions';
import { LocalStorageKeys } from '../../constants/LocalStorageKeys';

@Injectable()
export class PermissionService {
    public PermissionManager: PermissionManager;

    constructor() {
        //var userPermissions = localStorage.getItem('Permissions');
        
        //this.PermissionManager = new PermissionManager(AppPermissions, userPermissions);
        this.Initiate();
    }

    public Initiate() {
        var userPermissions = localStorage.getItem(LocalStorageKeys.Permissions);

        if (userPermissions)
            this.PermissionManager = new PermissionManager(AppPermissions, userPermissions);
    }
}